import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Rocket, CheckCircle } from "lucide-react";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-900 overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, rgba(255,255,255,0.1) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="relative z-10 container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/10 border border-blue-500/20 mb-8"
          >
            <span className="text-sm font-semibold text-blue-400">
              🚀 Solutions Digitales Innovantes
            </span>
          </motion.div>

          {/* Main title */}
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Transformez Votre
            <span className="block mt-2 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">
              Présence Digitale
            </span>
          </h1>

          {/* Description */}
          <p className="text-xl text-gray-300 mb-10 max-w-3xl mx-auto">
            Création de sites web professionnels, e-commerce, systèmes de gestion
            et stratégies marketing sur mesure pour propulser votre entreprise.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold rounded-xl hover:opacity-90 transition-opacity"
            >
              Demander un Devis Gratuit
              <ArrowRight className="w-5 h-5" />
            </Link>

            <Link
              to="/models"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-gray-700 text-white font-semibold rounded-xl hover:bg-gray-800/50 transition-colors"
            >
              <Rocket className="w-5 h-5" />
              Voir Nos Réalisations
            </Link>
          </div>

          {/* Features */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-2xl mx-auto">
            {[
              "Design Personnalisé",
              "Optimisé SEO",
              "Support 24/7",
              "Performance Max"
            ].map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1 }}
                className="flex items-center gap-2 p-3 bg-gray-800/50 rounded-lg"
              >
                <CheckCircle className="w-5 h-5 text-green-400" />
                <span className="text-sm text-gray-300">{feature}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}